import React from "react";
import ReactDOM /*render*/ from "react-dom";
import {
  BrowserRouter,
  /*HashRouter, Router,*/ Route,
  Switch,
} from "react-router-dom";
import "./index.css";

import Login from "./Login";
import Home from "./Home";
import Cadastro from "./Cadastro";
import Regras from "./Regras";
import Noticias from "./Noticias";
import NoticiaDescricao from "./NoticiaDescricao";
import Perfil from "./Perfil";
import PerfilAvatar from "./PerfilAvatar";
import Ranking from "./Ranking";
import PesquisaExtra from "./PesquisaExtra";
import MateriaisTreinamentos from "./MateriaisTreinamentos";
import Relatorios from "./Relatorios";
import GranularClassicoPesquisa from "./GranularClassicoPesquisa";
import IndiretoPesquisa from "./IndiretoPesquisa";
import Lojinha from "./Lojinha";
import Ecommerce from "./Ecommerce";
import Omnichannel from "./Omnichannel";
import FornadaDeVantagens from "./FornadaDeVantagens";
import AcademiaBunge from "./AcademiaBunge";
import AcademiaFormularioListaRequisicoes from "./AcademiaFormularioListaRequisicoes";
import AcademiaFinalizarRequisicao from "./AcademiaFinalizarRequisicao";
import AcademiaFormularioAtendimento from "./AcademiaFormularioAtendimento";
import AcademiaFormularioRequisicoes from "./AcademiaFormularioRequisicoes";
import AcademiaFormularioEncaminhaRequisicao from "./AcademiaFormularioEncaminhaRequisicao";
import AcademiaFormularioListaTecnico from "./AcademiaFormularioListaTecnico";
import AcademiaFormularioAtendimentoTecnico from "./AcademiaFormularioAtendimentoTecnico";
import AcademiaFormularioCalendario from "./AcademiaFormularioCalendario";
import Recompra1500Bonificacao from "./Pages/Recompra1500Bonificacao";
import BonificacaoIntroducao from "./Pages/BonificacaoIntroducao";
import Recompra1500 from "./Pages/Recompra1500";
import PotencialCompra from "./PotencialCompra";
import Merchandising from "./Merchandising";
import Teste from "./Teste";
import Descadastramento from "./Pages/Descadastramento";
import PremioFeira from "./PremioFeira";
import EditarRequisicao from "./Pages/AcademiaMinhaBunge/EditarRequisicao";
import Privacidade from "./Privacidade";

// PORTAL VENDEDOR
import ConsultarCadastro from "./PortalVendedor/ConsultarCadastro";
import ConsultarClientes from "./PortalVendedor/ConsultarClientes";
import VendedorUsers from "./PortalVendedor/VendedorUsers";
import VendedorLojas from "./PortalVendedor/VendedorLojas";
import Cupons from "./PortalVendedor/Cupons";
import Comercial from "./PortalVendedor/Comercial";
import Questionarios from "./PortalVendedor/Questionarios";
import Proprietario from "./PortalVendedor/Proprietario";
import FiltroPush from "./PortalVendedor/FiltroPush";

const getBasename = (path) => path.substr(0, path.lastIndexOf("/"));

ReactDOM.render(
  // <BrowserRouter basename={getBasename(window.location.pathname)}>
  <BrowserRouter>
    <Switch>
      <Route path="/Merchandising" exact component={Merchandising} />
      <Route path="/PotencialCompra" exact component={PotencialCompra} />
      {/* <Route path="/Desafio1500Lojas" exact component={Desafio1500Lojas} /> */}
      <Route path="/FornadaDeVantagens" exact component={FornadaDeVantagens} />
      <Route
        path="/AcademiaFormularioListaRequisicoes"
        exact
        component={AcademiaFormularioListaRequisicoes}
      />
      <Route
        path="/AcademiaFinalizarRequisicao"
        exact
        component={AcademiaFinalizarRequisicao}
      />
      <Route
        path="/AcademiaFormularioAtendimento"
        exact
        component={AcademiaFormularioAtendimento}
      />
      <Route
        path="/AcademiaFormularioRequisicoes"
        exact
        component={AcademiaFormularioRequisicoes}
      />
      <Route
        path="/AcademiaFormularioEncaminhaRequisicao"
        exact
        component={AcademiaFormularioEncaminhaRequisicao}
      />
      <Route
        path="/AcademiaFormularioListaTecnico"
        exact
        component={AcademiaFormularioListaTecnico}
      />
      <Route
        path="/AcademiaFormularioAtendimentoTecnico"
        exact
        component={AcademiaFormularioAtendimentoTecnico}
      />
      <Route
        path="/AcademiaFormularioCalendario"
        exact
        component={AcademiaFormularioCalendario}
      />
      <Route path="/AcademiaBunge" exact component={AcademiaBunge} />
      <Route path="/Omnichannel" exact component={Omnichannel} />
      <Route path="/Ecommerce" exact component={Ecommerce} />
      <Route path="/Lojinha" exact component={Lojinha} />
      <Route
        path="/GranularClassicoPesquisa"
        exact
        component={GranularClassicoPesquisa}
      />
      <Route path="/IndiretoPesquisa" exact component={IndiretoPesquisa} />
      <Route path="/relatorios" exact component={Relatorios} />
      <Route path="/conteudos" exact component={MateriaisTreinamentos} />
      <Route path="/pesquisaextra" exact component={PesquisaExtra} />
      <Route path="/ranking" exact component={Ranking} />
      <Route path="/perfilavatar" exact component={PerfilAvatar} />
      <Route path="/perfil" exact component={Perfil} />
      <Route path="/noticias" exact component={Noticias} />
      <Route path="/noticia/:customPath" exact component={NoticiaDescricao} />
      <Route path="/regras" exact component={Regras} />
      <Route path="/home" exact component={Home} />
      <Route path="/cadastro" exact component={Cadastro} />
      <Route path="/descadastramento" exact component={Descadastramento} />
      <Route path="/premiofeira/:customPath" exact component={PremioFeira} />
      <Route
        path="/BonificacaoeRecompra1500"
        exact
        component={Recompra1500Bonificacao}
      />
      <Route
        path="/BonificacaoIntroducao"
        exact
        component={BonificacaoIntroducao}
      />
      <Route path="/Recompra1500" exact component={Recompra1500} />
      <Route path="/EditarRequisicao" exact component={EditarRequisicao} />

      {/* ROTAS PORTAL VENDEDOR */}
      <Route path="/ConsultarCadastros" exact component={ConsultarCadastro} />
      <Route
        path="/ConsultarClientes/:cpf"
        exact
        component={ConsultarClientes}
      />
      <Route path="/VendedorLojas" exact component={VendedorLojas} />
      <Route path="/VendedorUsers" exact component={VendedorUsers} />
      <Route path="/PromocodeAdmin" exact component={Cupons} />
      <Route path="/Comercial" exact component={Comercial} />
      <Route path="/Questionario" exact component={Questionarios} />
      <Route path="/Proprietario" exact component={Proprietario} />
      <Route path="/FiltroPush" exact component={FiltroPush} />
      <Route path="/Privacidade" component={Privacidade} />

      <Route path="/" component={Login} />
    </Switch>
  </BrowserRouter>,document.getElementById("root")
)
